/** Компонент с дефолтной точкой прижатой к иконке */
export default defineComponent({
  name: 'CustomDotBadge'
});